import { Button, styled } from "@mui/material";

export const NewCreateButton = styled(Button)(({ theme }) => ({
    position: 'fixed',
    top: theme.spacing(9),
    right: theme.spacing(3),
}));